import { Progress, Spin } from "antd";
import { useTranslation } from "react-i18next";

type Props = {
  /** When false, renders nothing */
  loading: boolean;
  /** Minimum height of the loading region (e.g. grid area) */
  minHeight?: string | number;
};

/**
 * Centered spinner + active progress + step dots while list data is fetched.
 */
export default function ListFetchLoader({ loading, minHeight = 320 }: Props) {
  const { t } = useTranslation();

  if (!loading) return null;

  return (
    <div
      className="ac-list-fetch-loader"
      style={{
        minHeight: typeof minHeight === "number" ? `${minHeight}px` : minHeight,
      }}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={t("services.loadingData")}
    >
      <div className="ac-list-fetch-loader__panel">
        <Spin size="large" className="ac-list-fetch-loader__spin" />
        <p className="ac-list-fetch-loader__title">{t("services.loadingData")}</p>
        <p className="ac-list-fetch-loader__hint">
          {t("services.loadingDataHint")}
        </p>
        <div className="ac-list-fetch-loader__dots" aria-hidden>
          <span />
          <span />
          <span />
        </div>
        <Progress
          percent={0}
          showInfo={false}
          status="active"
          strokeColor={{
            "0%": "var(--ac-theme-primary)",
            "100%": "var(--ac-theme-accent)",
          }}
          trailColor="rgb(var(--ac-theme-accent-rgb) / 0.12)"
          className="ac-list-fetch-loader__progress"
        />
      </div>
    </div>
  );
}
